export type ThemePreference = 'light' | 'dark' | 'system' | 'schedule';

/** Resolved theme applied to CSS (light/dark only). */
export type ResolvedTheme = 'light' | 'dark';

/** Workspace settings.mode — alias for backward-compatible imports. */
export type ThemeType = ThemePreference;

export type ThemeSchedule = {
  lightFrom: string;
  darkFrom: string;
};

export const DEFAULT_THEME_SCHEDULE: ThemeSchedule = {
  lightFrom: '07:00',
  darkFrom: '20:00',
};

/** Gallery / static theme picker — light and dark only. */
export type GalleryThemeMode = ResolvedTheme;
